export default __webpack_public_path__ + "static/media/bread-bg.d0e49bca.jpg";